// Configuration constants for location services
export const CONFIG = {
  MAX_DISTANCE_KM: 50,
  DEFAULT_LOCATION: {
    city: 'new-delhi',
    state: 'delhi'
  },
  GPS_OPTIONS: {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 300000 // 5 minutes
  },
  LOCATION_CACHE_DURATION: 24 * 60 * 60 * 1000, // 24 hours
  LOCATION_STORAGE_KEY: 'user_location',
  LOCATION_EXPIRY_KEY: 'location_expiry'
};